/**
* Created by CHENRC2 on 2018-1-10.
*/
<template>
    <div class="logo-and-menu">
        <div class="logo-wrap">
            <div v-if="showisCollapsed">
                <img class="logo-wrap-img" src="../../../../assets/s-logo.svg" alt="" width="36" height="36">
                <img src="../../../../assets/systemLogo.svg" alt="" width="154" height="20">
            </div>
            <div v-if="showisCollapsed" class="logo-wrap-text">
                {{$translate('lang.E3202101220003', { defaultText: '家电二级节点管理平台 [美的]' })}}
            </div>
            <div v-if="!showisCollapsed" class="packUp-img">
                <img src="../../../../assets/s-logo.svg" alt="" width="36" height="36">
            </div>
        </div>
        <el-menu class="left-menu" :open-names="['1']" accordion @on-select="handleMenuSelect"
            mode="vertical" @open="handleOpen" @close="handleClose" :collapse-transition="false" :collapse="isCollapse"
            background-color="rgba(79, 93, 106, 1)" text-color="#fff" active-text-color="#fff" :unique-opened="true">
            <SidebarItem :menus="menus" :collapse="isCollapse">
            </SidebarItem>
        </el-menu>
    </div>
</template>
<style lang="less">
.logo-and-menu {
    .logo-wrap {
        display: flex;
        height: 143px;
        flex-direction: column;
        justify-items: center;
        align-items: center;
        .logo-wrap-img {
            display: block;
            margin: 26px auto 10px;
        }
        .packUp-img {
            padding-top: 20px;
        }
        .logo-wrap-text {
            text-align: center;
            width: 176px;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 12px;
            color: #FFFFFF;
            letter-spacing: 0;
            opacity: 0.8;
        }
    }
    .logo-icon {
        width: 176px;
    }
    .logo-text {
        width: 120px;
        margin-left: 0;
    }
    .left-menu {
        border-right: 0 none;
        background-color: #242c3e;
        color: #fff;
        .routeLink {
            &.router-link-active {
                .el-menu-item {
                    position: relative;
                    background: #4285f5 !important;
                    color: #ffffff !important;
                }
                .el-menu-item::before {
                    content: "";
                    position: absolute;
                    height: 100%;
                    background: #ffffff;
                    width: 4px;
                    left: 0px;
                    top: 0px;
                }
            }
        }
    }
}
</style>
<script>
import { navigate } from '../core';
import SidebarItem from './SidebarItem';
import { I18nMixins } from '@/utils/i18n';
import {
    getResourceNameByCode,
    sendInfoToBigData
} from '@/utils/asideMenuAction.js';
export default {
    name: 'CoreSidebarMenus',
    mixins: [I18nMixins],
    components: {
        SidebarItem
    },
    props: {
        menus: {
            type: Array,
            default () {
                return [];
            }
        },
        menuTitle: {
            default () {
                return '';
            }
        },
        menuCollpased: {
            default () {
                return false;
            }
        },
        collapse: {
            type: Boolean,
            default () {
                return true;
            }
        },
        showisCollapsed: {
            type: Boolean,
            default () {
                return false;
            }
        }
    },
    data() {
        return {
            menuchild: [],
            message: 'developer.message'
        };
    },
    computed: {
        isCollapse() {
            return this.collapse;
        }
    },
    methods: {
        // 菜单导航
        handleMenuSelect(routerLink) {
            navigate(this.$router, routerLink);
        },
        // 判断当前菜单子级是按钮还是空
        computedChildIsButtonOrNull(menu) {
            let hasSubOrNull = true;
            if (menu.children && menu.children.length > 0) {
                const childIsButton = menu.children.filter(m => m.fdType === 'F');
                hasSubOrNull = childIsButton.length > 0;
            }
            return hasSubOrNull;
        },
        handleOpen(key, keyPath) {
            getResourceNameByCode(key, this.menus);
            sendInfoToBigData();
        },
        handleClose(key, keyPath) {
            getResourceNameByCode(key, this.menus);
            sendInfoToBigData();
        }
    }
};
</script>
